<template>
  <div>
    <mds-page-shell :logo="getProductLogo()" :logo-responsive="getProductLogo()" logo-href="/" logo-alt="Back to home page">
      <div class="review-form-main">
        <div class="review-form">
          <div class="review-form-container">
            <div style="padding-top:10px">
              <mds-alert mds-alert-dismissed :variation="paymentAlertVariation" class="alert-message" v-if="alertState"
                @mds-alert-dismissed="closeAlert()" :tinted="alertState">
                {{ alertMessage }}
              </mds-alert>
            </div>
            <div>
              <h1 class="review-page-title">Activate your subscription</h1>
            </div>
            <div class="review-page-border"></div>
            <div>
              <h1 class="review-form-field">Account</h1>
              <span class="review-form-value">{{ userDetails.email }}</span>
            </div>
            <div v-if="isMFISubscribe">
              <div class="review-page-border"></div>
              <h1 class="review-form-field">Morningstar FundInvestor</h1>
              <div class="tax-details">
                <span class="review-form-value-term">{{
                  MFIProductSubscriptionTerm
                }}</span>
                <span class="review-form-value-price">
                  ${{ MFIOriginalPrice || MFIProductPrice | customDataFilter }}
                </span>
              </div>
              <div class="tax-details" v-if="MFIOriginalPrice">
                <span class="review-form-value-term"> Discounted Rate - {{
                  promoCode
                }}</span>
                <span class="review-form-value-price">${{ MFIProductPrice-MFIOriginalPrice | customDataFilter }}</span>
              </div>
              <div class="tax-details">
                <span class="review-form-value-term">Tax</span>
                <span class="review-form-value-price">${{ MFISubscriptionTax | customDataFilter }}</span>
              </div>
            </div>
            <div v-if="isMSISubscribe">
              <div class="review-page-border"></div>
              <h1 class="review-form-field">Morningstar StockInvestor</h1>
              <div class="tax-details">
                <span class="review-form-value-term">{{
                  MSIProductSubscriptionTerm
                }}</span>
                <span class="review-form-value-price">
                  ${{ MSIOriginalPrice || MSIProductPrice | customDataFilter }}
                </span>
              </div>
              <div class="tax-details" v-if="MSIOriginalPrice">
                <span class="review-form-value-term"> Discounted Rate - {{
                  promoCode
                }}</span>
                <span class="review-form-value-price">${{ MSIProductPrice-MSIOriginalPrice | customDataFilter }}</span>
              </div>
              <div class="tax-details">
                <span class="review-form-value-term">Tax</span>
                <span class="review-form-value-price">${{ MSISubscriptionTax | customDataFilter }}</span>
              </div>
            </div>
            <div v-if="isMDISubscribe">
              <div class="review-page-border"></div>
              <h1 class="review-form-field">Morningstar DividendInvestor</h1>
              <div class="tax-details">
                <span class="review-form-value-term">{{
                  MDIProductSubscriptionTerm
                }}</span>
                <span class="review-form-value-price">
                  ${{ MDIOriginalPrice || MDIProductPrice | customDataFilter }}
                </span>
              </div>
              <div class="tax-details" v-if="MDIOriginalPrice">
                <span class="review-form-value-term"> Discounted Rate - {{
                  promoCode
                }}</span>
                <span class="review-form-value-price">${{ MDIProductPrice-MDIOriginalPrice | customDataFilter }}</span>
              </div>
              <div class="tax-details">
                <span class="review-form-value-term">Tax</span>
                <span class="review-form-value-price">${{ MDISubscriptionTax | customDataFilter }}</span>
              </div>
            </div>
            <div v-if="isMEISubscribe">
              <div class="review-page-border"></div>
              <h1 class="review-form-field">Morningstar ETFInvestor</h1>
              <div class="tax-details">
                <span class="review-form-value-term">{{
                  MEIProductSubscriptionTerm
                }}</span>
                <span class="review-form-value-price">
                  ${{ MEIOriginalPrice || MEIProductPrice | customDataFilter }}
                </span>
              </div>
              <div class="tax-details" v-if="MEIOriginalPrice">
                <span class="review-form-value-term"> Discounted Rate - {{
                  promoCode
                }}</span>
                <span class="review-form-value-price">${{ MEIProductPrice-MEIOriginalPrice | customDataFilter }}</span>
              </div>
              <div class="tax-details">
                <span class="review-form-value-term">Tax</span>
                <span class="review-form-value-price">${{ MEISubscriptionTax | customDataFilter }}</span>
              </div>
            </div>
            <div class="review-total-price-summary">
              <div class="review-page-border-last"></div>
              <div class="review-page-total-wrapper">
                <strong class="review-due-today">Total due Today</strong>
                <span class="review-total-price">${{ totalPrice | customDataFilter }}</span>
              </div>
            </div>
            <div class="review-price-summary-info">
              <span>You will automatically be billed for your annual subscription term.</span>
            </div>
            <div class="review-price-summary-details">
              <span>Yearly subscriptions are billed once per year.</span><br /><span>
                Quarterly subscriptions are billed every three months.</span>
            </div>
            <div class="review-page-border-last"></div>

            <div>
              <mds-loader size="small" aria-label="Small Loader" v-if="!isCreditCardDataPopulated"></mds-loader>
              <payment-form 
                v-if="userDetails && isCreditCardDataPopulated"
                ref="paymentForm"
                @validity-changed="updateChildValidity"
                @processing-changed="updateProcessingState"
                @payment-state="updatePaymentState"
                @payment-failed="updatePaymentFailed"
                :payment-data="{
                  userDetails: this.userDetails,
                  selectedProducts: this.selectedProducts
                }"
                :creditCardData="creditCardInfo"
                :processing="processing"
              />
            </div>

            <div class="review-button-container">
              <div>
                <mds-button-container left-aligned>
                  <mds-button variation="secondary" size="large" @click="
                    $router.push({
                      name: 'autorenew',
                      params: { productcode: $route.params.productcode },
                      query: { offerCode: $route.query.offerCode }
                    })
                    " :disabled="processing">
                    Back
                  </mds-button>
                  <div class="review-cancel-button">
                    <mds-button variation="secondary" size="large" id="cancelButton" @click="CancelEvent()" :disabled="processing">
                      Cancel
                    </mds-button>
                  </div>
                  <div class="review-submit-button">
                    <mds-button variation="primary" size="large" @click="submitPayment" :disabled="!childValid || processing">
                      Submit
                    </mds-button> 
                  </div>
                </mds-button-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mds-page-shell>
  </div>
</template>
<script>
import MdsAlert from "@mds/alert";
import MdsLoader from "@mds/loader";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsPageShell from '@mds/page-shell';
import EncryptDecryptMixin  from "../../mixins/EncryptDecryptMixin";
import { postData } from "@/utilities/API/apiUtility";
import PaymentForm from './PaymentForm.vue';
import { GetSessionData } from "@/utilities/userDataUtility";
import {  getUserDetailsFromStripe, getCustomerFromStripe, getDefaultCreditCard } from '@/utilities/stripe';
export default {
  name: "review-subscription-confirmation",
  mixins:[EncryptDecryptMixin],
  components: {
    MdsPageShell,
    MdsButton,
    MdsButtonContainer,
    MdsLoader,
    MdsAlert,
    PaymentForm 
  },
  data() {
    return {
      MFIProductPrice: 0.0,
      MSIProductPrice: 0.0,
      MDIProductPrice: 0.0,
      MEIProductPrice: 0.0,
      MFIProductSubscriptionTerm: null,
      MSIProductSubscriptionTerm: null,
      MDIProductSubscriptionTerm: null,
      MEIProductSubscriptionTerm: null,
      isMFISubscribe: false,
      isMSISubscribe: false,
      isMDISubscribe: false,
      isMEISubscribe: false,
      MFISubscriptionTax: this.GetTaxAmount('MFITaxAmount'),
      MSISubscriptionTax: this.GetTaxAmount('MSITaxAmount'),
      MDISubscriptionTax: this.GetTaxAmount('MDITaxAmount'),
      MEISubscriptionTax: this.GetTaxAmount('MEITaxAmount'),

      totalPrice: 0.00,
      userDetails: [],
      productSubscription: [],
      MFISubscriptionData: null,
      MSISubscriptionData: null,
      MDISubscriptionData: null,
      MEISubscriptionData: null,
      uID:"",

      /*Stripe data*/
      userID:null, // UIM GUID
      liststripeCountry: this.$store.state.country.stripeCountryList,
      selectedProducts:[],
      childValid: false,
      processing: false,
      paymentState:false, 
      paymentFailed:false,
      paymentAlertVariation:false,
      alertMessage:'',
      alertState:false,
      addUserRolesURL : process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_ADD_USER_ROLES,
      creditCardInfo: null,
      isCreditCardDataPopulated : false, // We need this flag only when user is logged in and credit card data is fetched completely
      isLoggedIn:false,

      MFIOriginalPrice:null,
      MSIOriginalPrice:null,
      MDIOriginalPrice:null,
      MEIOriginalPrice:null,
      promoCode:null,
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.$store.state.layout.isHeaderRequired = false;
    this.$store.state.layout.isFooterRequired = false;
    this.isLoggedIn = this.$store.state.user.LoggedIn;
    if (this.isLoggedIn){
      this.userID = this.$auth0.user["https://morningstar.com/mstar_id"];      
    }
    await this.getDataFromlocalStorage();
    await this.GetProductSelection();
    await this.GetUserDetails();
    if(this.$store.state.user.LoggedIn){
      await this.fetchCreditCardDetails();
      // ONLY FOR OMAHA USERS (as Credit card info not available in the stripe yet)
      if(!this.creditCardInfo){
        this.isCreditCardDataPopulated = true;
      }
    }else{
      this.isCreditCardDataPopulated = true;
    }

  },
  methods: {
    async closeAlert() {
      this.alertState = false;
    },
    getProductLogo() {
      var images = require.context(
        "../../../assets/Images",
        false,
        /\.svg$/
      );
      return images("./Common.svg");
    },
    async getDataFromlocalStorage() {
      const subscriptionKeys = [
        { key: "MFIProductSubscription", prefix: "MFI" },
        { key: "MSIProductSubscription", prefix: "MSI" },
        { key: "MDIProductSubscription", prefix: "MDI" },
        { key: "MEIProductSubscription", prefix: "MEI" }
      ];

      for (const { key, prefix } of subscriptionKeys) {
        var subscriptionData = this.getSubscriptionData(key);
        if (subscriptionData && subscriptionData.Price != null) {
          this[`${prefix}SubscriptionData`] = subscriptionData;
          this[`is${prefix}Subscribe`] = true;
          this[`${prefix}ProductPrice`] = subscriptionData.Price;
          this[`${prefix}ProductSubscriptionTerm`] = subscriptionData.subscriptionterm.replace("Annual", "Yearly");
          this[`${prefix}OriginalPrice`]= subscriptionData.originalPrice;
          if (subscriptionData.promocode) {
            this.promoCode = subscriptionData.promocode;
          }
        }
      }

      this.totalPrice = this.calculateTotalPrice(
        this.MFIProductPrice,
        this.MSIProductPrice,
        this.MDIProductPrice,
        this.MEIProductPrice,
        this.MFISubscriptionTax,
        this.MSISubscriptionTax,
        this.MDISubscriptionTax,
        this.MEISubscriptionTax
      );
    },
    calculateTotalPrice(
      MFIProductPrice,
      MSIProductPrice,
      MDIProductPrice,
      MEIProductPrice,
      MFISubscriptionTax,
      MSISubscriptionTax,
      MDISubscriptionTax,
      MEISubscriptionTax
    ) {
      var totalPrice =
      (parseFloat(MFIProductPrice) || 0) +
      (parseFloat(MSIProductPrice) || 0) +
      (parseFloat(MDIProductPrice) || 0) +
      (parseFloat(MEIProductPrice) || 0) +
      (parseFloat(MFISubscriptionTax) || 0) +
      (parseFloat(MSISubscriptionTax) || 0) +
      (parseFloat(MDISubscriptionTax) || 0) +
      (parseFloat(MEISubscriptionTax) || 0);
      return totalPrice;
    },
    getSubscriptionData(key) {
      const encryptedData = localStorage.getItem(key);
      if (!encryptedData) return null;

      const decryptedData = this.Decrypt(encryptedData);
      if (!decryptedData) return null;

      return JSON.parse(decryptedData);
    },
    /* STRIPE RELATED METHODS */
    GetProductSelection(){
      const productFlags = [
        { product: 'MDI', flag: this.isMDISubscribe },
        { product: 'MSI', flag: this.isMSISubscribe },
        { product: 'MFI', flag: this.isMFISubscribe },
        { product: 'MEI', flag: this.isMEISubscribe },
      ];
      this.selectedProducts = [];
      productFlags.forEach(({ product, flag }) => {
        if (flag) {
          this.selectedProducts.push(product);
        }
      });
    },

    async GetUserDetails() {
      try {
        if (!this.userID) {
            // const encryptedData = localStorage.getItem("u9");
            // if (!encryptedData) return;

            // const decryptedData = this.Decrypt(encryptedData);
            // if (!decryptedData) return;

            // const parsedData = JSON.parse(decryptedData);
            const sessionData = await GetSessionData(this.$session);
            this.userID = sessionData.UIMId;
            if (!this.userID) return;
          }
          if(this.isLoggedIn) {
            this.userDetails = await getUserDetailsFromStripe('newsletters',this.userID);
            if(!this.userDetails) {
              await this.GetCustomerById();
            }
          } else {
            await this.GetCustomerById();
          }
      } catch (error) {
          console.error('Error fetching user details from Stripe:', error);
      }
     
    },

    async GetCustomerById(){
      const sessionData = await GetSessionData(this.$session);
      const customerID = sessionData.StripeCustId;
      this.userDetails = await getCustomerFromStripe(customerID);
    },

    GetTaxAmount(key){
      const taxData = localStorage.getItem(key);
      return taxData ? JSON.parse(taxData).taxamount : 0;
    },
    updateChildValidity(isValid) {
      this.childValid = isValid;
    },
    updateProcessingState(isProcessing) {
      this.processing = isProcessing;
      this.alertEvent("Payment in Progress...");
    },
    updatePaymentState(paymentState){
      //This state is for success when card is marked as default successfully in stripe
      this.paymentState = paymentState;
      this.alertEvent("Payment in Progress...");
    },
    updatePaymentFailed(payload){
      this.paymentFailed = payload.flag;
      this.alertEvent(payload.message);
    },
    submitPayment(){
      if (this.childValid && !this.processing) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.$refs.paymentForm.handleSubmit();
      }
    },
    CancelEvent() {
      this.$router.push({
        name: "combined-home",
        params: { currentproduct: "Common" },
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          console.log(err);
        }
      });
    },
    async alertEvent(message){
      this.alertState=true;
      if(this.processing){
        this.paymentAlertVariation="informational";
        this.alertMessage=message;
      }
      if(this.paymentState){
        this.processing = true;
        this.paymentAlertVariation="informational";
        this.alertMessage=message;
        const isSubscriptionCreated = await this.CreateStripeSubscription();
        if(isSubscriptionCreated){
          await this.UpdateUserConsents();
          const isUimRoleCreated = await this.createUIMRoles();
          if(isUimRoleCreated){
            this.processing = false;
            setTimeout(() => {
              this.pushToThankYouPage();
            },400);
          }
        }else{
          this.processing = false;
        }
        await this.ClearLocalStorage();
      }
      if(this.paymentFailed){
        this.paymentAlertVariation="error";
        this.alertMessage=message;
      }
    },
    async UpdateUserConsents() {
      let updateUserConsents = false;
      this.isLoading = true;

      try {
        let savedconsents = this.Decrypt(localStorage.getItem("userConsents"));
        if (savedconsents) {
          savedconsents = JSON.parse(savedconsents);
          this.userConsents = savedconsents.UserConsents;
        }

        this.selectedProducts.forEach(product => {             
          if (product) {
            updateUserConsents = true;
            if (this.userConsents == null || this.userConsents == undefined || this.userConsents.length == 0) {
              this.userConsents = {}; // Initialize as an object, not an array
              this.userConsents.user = this.userID;
              this.userConsents.Ids = []; // Initialize Ids as an empty array
            }
            this.userConsents.Ids.push(product.toLowerCase() + "-alerts-opt-in");
          }
        });
        if (updateUserConsents == true) {
          var AddUpdateUserConsentsUrl = process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_AddUpdateUserConsents;

          const postResponse = await postData(AddUpdateUserConsentsUrl, this.userConsents);

          if (!postResponse || postResponse.status !== 200) {
            //except console nothing was here so kept it for dev env
            if (process.env.NODE_ENV == 'development') {
              console.log("Error updating consents");
            }
          }
        }
      } catch (error) {
        if (process.env.NODE_ENV == 'development') {
          console.log("Error in UpdateUserConsents:", error);
        }
      }
    },
    async createUIMRoles() {
      this.productCodes = [];
      const productCodeMap = {
        'MSI': 'NM00000001',
        'MDI': 'NDI0000001',
        'MEI': 'NET0000001',
        'MFI': 'NF00000001'
      };

      this.selectedProducts.forEach(product => {
        if (productCodeMap[product]) {
          this.productCodes.push(productCodeMap[product]);
        }
      });

      try{
        const response = await postData(this.addUserRolesURL, { userId:this.userID,productCode: this.productCodes });
        if(response){
          if(response.data.message.includes("roles added successfully to UIM")){
              return true;
          }else{
            this.paymentAlertVariation="warning";
            this.alertMessage = "Your subscription has been created. If you don't see it after logging in, please reach out to support for assistance.";
            return false;
          }
        }
      }catch(error){
        this.paymentAlertVariation="warning";
        this.alertMessage = "Your subscription has been created. If you don't see it after logging in, please reach out to support for assistance.";
        return false;
      }
    },
    async CreateStripeSubscription(){
      const subscriptions = {
        MFI: { data: this.MFISubscriptionData, amount:this.MFIProductPrice, productName: "FundInvestor", taxAmount : this.MFISubscriptionTax},
        MSI: { data: this.MSISubscriptionData, amount:this.MSIProductPrice,productName: "StockInvestor", taxAmount : this.MSISubscriptionTax },
        MDI: { data: this.MDISubscriptionData, amount:this.MDIProductPrice, productName: "DividendInvestor", taxAmount : this.MDISubscriptionTax },
        MEI: { data: this.MEISubscriptionData, amount:this.MEIProductPrice, productName: "ETFInvestor", taxAmount : this.MEISubscriptionTax },
      };

      Object.keys(subscriptions).forEach(product => {
        const { data, amount, productName, taxAmount } = subscriptions[product];
        if (data != null) {
          this.productSubscription.push({
            priceId: data.priceid,
            Amount: amount,
            productName: productName,
            TaxAmount : taxAmount
          });
        }
      });

      const promoCode = this.getPromocodeValueFromLocal();
      const customerId = this.userDetails.id;


      const url = process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_CREATE_SUBSCRIPTION;
      try{
        const response = await postData(url, { customerId:customerId,subscriptions: this.productSubscription,promoCode:promoCode });
        if(response && response.status === 200 && response.data.isSuccessful){
          this.paymentAlertVariation="success";
          this.alertMessage = "Subscription Created Successfully";
          return true;
        }else{
          this.paymentAlertVariation="error";
          this.alertMessage = "There was a problem creating your subscription. Please try again later.";
          return false;
        }
      }catch(error){
        this.paymentAlertVariation="error";
        this.alertMessage = "There was a problem creating your subscription. Please try again later.";
        if (process.env.NODE_ENV == 'development') {
          console.log('ReviewSubscriptionConfirmation page createStripeSubscription error : ',error.message);
        }
        return false;
      }
    },
    getPromocodeValueFromLocal(){
      const encryptedData = localStorage.getItem("promocode");
      if (!encryptedData) return;

      const decryptedData = this.Decrypt(encryptedData);
      if (!decryptedData) return;

      return decryptedData ? JSON.parse(decryptedData) : null;
    },
    async ClearLocalStorage(){ 
      localStorage.removeItem("userConsents");     
      localStorage.removeItem("promocode");
      localStorage.removeItem("MDITaxAmount");
      localStorage.removeItem("MEITaxAmount");
      localStorage.removeItem("MFITaxAmount");
      localStorage.removeItem("MSITaxAmount");
      localStorage.removeItem("c42"); // Removing stripe customer id from localstorage
    },
    pushToThankYouPage(){
      this.$router.push({
        name: "subscriptionconfirmation",
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          console.log(err);
        }
      });
    },
    async fetchCreditCardDetails(){
      try {
        if (this.userDetails && this.userDetails.id) {
          const values = await getDefaultCreditCard(this.userDetails.id);
          this.creditCardInfo = values;
          this.isCreditCardDataPopulated = this.creditCardInfo ? true : false;
        }
      } catch (error) {
        if (process.env.NODE_ENV == 'development') {
          console.error('Error fetching credit card info');
        }
      }
    }
  }
};
</script>

<style scoped>
.review-form-container {
  width: 380px;
  margin: 0 auto;
}

.tax-details {
  margin-top: 1.2%;
}

.review-price-summary-details {
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #1e1e1e;
}

.review-price-summary-info {
  margin-top: 8% !important;
  margin-bottom: 3% !important;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #1e1e1e;
}

.review-due-today {
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
}

.review-total-price {
  float: right;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  text-align: right;
  color: #000000;
}

.review-form-value-price {
  float: right;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  text-align: right;
  color: #000000;
}

.review-form-value-term {
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
}

.review-form-value {
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  text-align: right;
  color: #000000;
  float: right;
  margin-top: -5%;
}

.review-form-field {
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
  margin-top: 2%
}

.review-page-border {
  width: 100%;
  border-bottom: 1px solid #ccc;
  margin-top: 8%;
}

.review-page-border-last {
  width: 100%;
  border-bottom: 1px solid #808080;
  margin-top: 5%;
}
.review-page-total-wrapper{
  margin-top:2%;
}

.review-form-main {
  height: 100%;
  min-height: 100vh;
  background: #f2f2f2;
}

.review-page-title {
  margin-top: 0px;
  margin-bottom: 15%;
  height: 44px;
  padding-top: 57px;
  font-weight: 250;
  font-size: 28px;
  line-height: 34px;
}

.review-form {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  background-color: #fff;
  height: 100%;
  min-height: 100vh;
}

.alert-message {
  margin-top: 5% !important;
  width: 100%;
}

.back-button {
  margin-top: -20.5%;
}
.review-button-container {
  margin-top: 10%;
}
.review-submit-button {
  margin-left:10px;
  order:2;
}
.review-cancel-button {
  margin-left:auto;
}

@media only screen and (max-width: 480px) {
  .review-form-container {
    width: 90%;
    margin: 0 auto;
  }
  .review-page-title {
    padding-top: 28px;
}
.review-page-border {
  margin-top: 10%;
}
}

@media only screen and (min-width: 321px) and (max-width: 360px) {
  .back-button {
    margin-top: -24%;
  }
}

@media only screen and (min-width: 361px) and (max-width: 393px) {
  .back-button {
    margin-top: -22%;
  }
}

@media only screen and (min-width: 394px) and (max-width: 414px) {
  .back-button {
    margin-top: -21%;
  }
}

@media only screen and (min-width: 415px) and (max-width: 428px) {
  .back-button {
    margin-top: -20%;
  }
}

@media only screen and (min-width: 429px) and (max-width: 460px) {
  .back-button {
    margin-top: -24%;
  }
}
</style>

